var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 56H13.998C13.4676 56 12.9589 55.7893 12.5838 55.4142C12.2088 55.0392 11.998 54.5304 11.998 54V10C11.998 9.46957 12.2088 8.96086 12.5838 8.58579C12.9589 8.21071 13.4676 8 13.998 8H38L52 22V54C52 54.2626 51.9483 54.5227 51.8478 54.7654C51.7473 55.008 51.5999 55.2285 51.4142 55.4142C51.2285 55.5999 51.008 55.7473 50.7654 55.8478C50.5227 55.9483 50.2626 56 50 56Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 8V22H52.002",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 27.999C22 27.999 18 37 18 37C18 37 22 45.999 32 45.999C42 45.999 46 37 46 37C46 37 42 27.999 32 27.999Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 42.0001C34.7614 42.0001 37 39.7615 37 37.0001C37 34.2386 34.7614 32.0001 32 32.0001C29.2386 32.0001 27 34.2386 27 37.0001C27 39.7615 29.2386 42.0001 32 42.0001Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEye);
export default __webpack_public_path__ + "static/media/FileEye.ebb7ea5888a208bcd3492bb87aabaa84.svg";
export { ForwardRef as ReactComponent };